import { Component } from 'react';
import { Link } from 'react-router-dom';

export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV === 'test') return;
    // Keep details out of the UI while still leaving a safe development signal.
    console.error('Route failed to render', error?.name || 'RouteError');
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="min-h-[70vh] bg-[#f6efe3] px-5 py-24 text-[#22362f]" data-testid="route-error-boundary">
        <section className="mx-auto max-w-2xl border border-[#d8c8ab] bg-[#fff9ee] p-8">
          <p className="text-xs uppercase tracking-[0.18em] text-[#7b694d]" data-testid="route-error-eyebrow">Something interrupted this page</p>
          <h1 className="mt-3 font-serif-display text-4xl font-medium" data-testid="route-error-title">Let’s get you back on track.</h1>
          <p className="mt-4 text-sm leading-relaxed text-[#5f6c64]" data-testid="route-error-copy">
            This view could not load safely. Your profile, jobs, and documents are not changed.
          </p>
          <Link to="/my-jobs" className="mt-6 inline-flex min-h-[44px] items-center border border-[#22362f] px-5 text-sm font-medium" data-testid="route-error-my-jobs-link">
            Go to My Jobs
          </Link>
        </section>
      </main>
    );
  }
}